export function initTransferMessageData(message) {
    return {
      message: message,
      isTransferMessageError: false
    }
  }